import { types } from "../types/types"

const initialState = {
    loading: false,
    msgError: null,
    data: null
}

export const uiReducer = (state = initialState, action) => {
    switch(action.type){
        case types.uiSetError:
            return {
                ...state,
                msgError: action.payload
            }
        case types.uiRemoveError:
            return {
                ...state,
                msgError: null
            }
        case types.uiStartLoading:
            return {
                ...state,
                loading: true
            }
        case types.uiFinishLoading:
            return {
                ...state,
                loading: false
            }
        case types.uiParameters:
            return {
                ...state,
                data: action.payload.data
            }
        default:
            return state;
    }
}
/*
const initState = {
    sidebarShow: 'responsive'
  };

export const changeState = (state = initState, { type, ...rest }) => {
    switch (type) {
      case 'set':
        return {...state, ...rest }
      default:
        return state;
    }
  }*/